import api from './api';

/**
 * Positions: awarded course sections, computed by the server on every read.
 * The server decides which positions the caller sees and which fields each
 * carries; a student receives only released positions with a place open now.
 */
export const positionService = {
    /**
     * The positions the caller may see, as { positions, total }
     * @param {{ program: string, term: string }} query
     */
    async listPositions({ program, term }) {
        const response = await api.get('/position', {
            params: { program, term },
        });
        return response.data;
    },

    /**
     * One position, in the shape listPositions gives each row.
     * @param {string} applicationId - the awarded course support application
     * @param {string} program - 'si', 'ta' or 'la'
     */
    async getPosition(applicationId, program) {
        const response = await api.get(`/position/${applicationId}`, {
            params: { program },
        });
        return response.data;
    },

    /**
     * Who holds a position's places, as { position, holders }: names only.
     * @param {string} applicationId - the awarded course support application
     * @param {string} program - 'si' or 'la'
     */
    async getStaffing(applicationId, program) {
        const response = await api.get(`/position/${applicationId}/staffing`, {
            params: { program },
        });
        return response.data;
    },
};

export default positionService;
